import { type AppContext, appFetch, getAppUrl } from './appClient';
import { apiVersions } from './endpoints';
import {
  getLocalPluginUrl,
  isLocalMode,
  localFetch,
} from './localRuntimeClient';

type DeleteWorkflowOptions = AppContext & {
  workflowNames: string[];
};

/**
 * Delete one or more workflows and every known per-workflow artifact.
 * Files must be removed before the directory because cloud VFS directory
 * deletion fails when designer sidecars leave it non-empty.
 */
export const deleteWorkflows = async (opts: DeleteWorkflowOptions): Promise<void> => {
  if (isLocalMode()) {
    for (const name of opts.workflowNames) {
      const url = `${getLocalPluginUrl()}/local/workflows/${name}`;
      await localFetch(url, { method: 'DELETE' });
    }
    return;
  }

  if (opts.workflowNames.length === 0) {
    return;
  }

  const accessToken = await opts.getToken();
  if (!accessToken) {
    throw new Error('Failed to get access token for request');
  }

  const url = `${getAppUrl(opts)}/deployWorkflowArtifacts?api-version=${apiVersions.otto}`;
  const filesToDelete = opts.workflowNames.flatMap((name) => [
    `${name}/workflow.json`,
    `${name}/workflow-draft.json`,
    `${name}/nodesMetadata.json`,
    `${name}/mockData.json`,
    `${name}/`,
  ]);

  await appFetch(url, accessToken, {
    method: 'POST',
    body: JSON.stringify({ filesToDelete }),
  });
};
